// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetFormResponse = App.Http.Responses.Form.GetFormResponse;
import GetFormsResponse = App.Http.Responses.Form.GetFormsResponse;
import StoreFormRequest = App.Http.Requests.Form.StoreFormRequest;
import GetFormsRequest = App.Http.Requests.Form.GetFormsRequest;
import FormData = App.Data.FormData;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class FormApi extends TenantBaseApi {
    /**
     * Get list of forms
     *
     * - Request: GetFormsRequest
     * - Response: GetFormsResponse
     */
    async index(request: GetFormsRequest) {
        return await this.get<GetFormsResponse, GetFormsRequest>("/forms", {
            params: request,
        });
    }

    /**
     * Store Form
     *
     * - Request: StoreFormRequest
     * - Response: GetFormResponse
     */
    async store(request: StoreFormRequest) {
        return await this.post<GetFormResponse, StoreFormRequest>("/forms", request);
    }

    /**
     * Get specific form
     *
     * - Request: { id: string }
     * - Response: GetFormResponse
     */
    async show(formId: string, request) {
        return await this.get<GetFormResponse, null>(`/forms/${formId}`, {
            params: request,
        });
    }

    /**
     * Update Form
     *
     * - Request: UpdateFormRequest
     * - Response: GetFormResponse
     */
    async update(request: StoreFormRequest, formId: string) {
        return await this.put<GetFormResponse, StoreFormRequest>(`/forms/${formId}`, request);
    }

    /**
     * Delete Form
     *
     * - Request: FormData
     * - Response: void
     */
    async destroy(form: FormData) {
        return await this.delete<void>(`/forms/${form.id}`);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/forms/export", request);
    }
}

export const formApi = new FormApi();
